import React from 'react';
import { useParams } from 'react-router-dom';

import HtmlHead from '../UI/Head/HtmlHead';
import { useRedirectWithConfigVersion } from '../../hooks/useRedirectWithConfigVersion';

export const DashCallLead = ({ prefix }) => {
  const { id, callId } = useParams();
  const { error } = useRedirectWithConfigVersion({
    id,
    context: 'dashboard',
    uris: [
      'calls',
      'leads',
      callId,
    ]
  });
  return (
    <>
      <HtmlHead repairy />
      <p style={{
                padding: '10px 50px',  
              }}>
        {
          error
            ? <>
                Opps! Seems like we cant provide you a service now. 
                Please contact support if problem persists
              </> 
            : <>Redirecting...</>
        }
      </p>
    </>
  );
}
